"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdTable = _interopRequireDefault(require("cccisd-table"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var statusLabels = {
  flagged: 'Unresolved',
  unflagged: 'Resolved'
};
var FlagHistory = function FlagHistory(props) {
  var history = props.history;
  var columns = [{
    name: 'status',
    label: 'Status',
    render: function render(value, row) {
      var unresolved = value === 'flagged';
      if (!statusLabels[value]) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])('badge', unresolved ? 'bg-danger' : 'bg-success')
      }, statusLabels[value]);
    }
  }, {
    name: 'reason',
    label: 'Note'
  }, {
    name: 'updatedAt',
    label: 'Updated At',
    render: function render(value, row) {
      return (0, _format["default"])(new Date(value), 'MM/dd/yyyy h:mm a');
    }
  }, {
    name: 'updatedBy',
    label: 'Updated By',
    render: function render(value, row) {
      return row.updatedBy.firstName ? "".concat(row.updatedBy.firstName, " ").concat(row.updatedBy.lastName) : row.updatedBy.email;
    }
  }];
  return /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
    columns: columns,
    data: history,
    rowKey: "updatedAt",
    showPerPageOptions: false,
    hideShowingRowsSummary: true
  });
};
FlagHistory.propTypes = {
  history: _propTypes["default"].array,
  closeModal: _propTypes["default"].func
};
var _default = exports["default"] = FlagHistory;